import React, { ReactNode } from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, Icon } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import withProps from '@/components/withProps';
import { SCREEN_SIZE } from '@/lib/theme';

const StyledBox = withProps({
  mt: '4',
  bg: 'white',
  position: 'relative',
  border: '1',
  borderColor: 'greys.alto',
  borderRadius: '4px',
  display: 'grid',
  py: '6',
  px: ['6', null, '9'],
})(styled(Box)`
  grid-template-columns: 1fr;
  gap: 24px;

  ${SCREEN_SIZE.MD} {
    grid-template-columns: 1fr 350px;
  }

  ${(props: { isSelected?: boolean }) =>
    props.isSelected &&
    css`
      border: 2px solid ${themeGet('colors.brand.primary')(props)};
    `};
`) as React.FC<FlightsSegmentBoxProps>;

const TopRightBox = withProps({
  bg: 'brand.primary',
  borderRadius: '18px',
  width: '24px',
  height: '24px',
  paddingLeft: '5px',
})(styled(Box)`
  position: absolute;
  top: -16px;
  right: -16px;
`) as React.FC<{ children: ReactNode }>;

interface FlightsSegmentBoxProps {
  isSelected?: boolean;
  children: ReactNode;
}

const FlightsSegmentBox = React.memo(
  ({ isSelected = false, children, ...props }: FlightsSegmentBoxProps) => (
    <StyledBox isSelected={isSelected} {...props}>
      {children}
      {isSelected && (
        <TopRightBox>
          <Icon color="white" name="check" size={14} />
        </TopRightBox>
      )}
    </StyledBox>
  ),
);

export default FlightsSegmentBox;
